module.exports = __webpack_public_path__ + "img/send.5b290d5a.svg";